import PartnerForm from './PartnerForm'

export default PartnerForm;